export const marketingActions = {
  'bestof2022.collection.click': {
    eventType: 'engagement',
    entityTypes: ['ui'],
    eventData: {
      uiType: 'button'
    },
    description: 'Banner at top of My List - Best of 2022 Collection'
  },
  'bestof2022.collection.impression': {
    eventType: 'impression',
    entityTypes: ['ui'],
    eventData: {
      component: 'ui',
      uiType: 'button'
    },
    description: 'Banner at top of Saves - Best of 2022 Collection'
  }
}
